import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { UiButton } from "../../../../components";
import "../ApproveLawyerModal/style.scss";

const ApproveAccountModal = ({
    isVisible,
    onClose,
    onConfirm,
    isLoading,
    record
}) => {
    const profile = record?.lawyerDetails;
    const lawyerName = profile ? `${profile?.firstName || ""} ${profile?.middleName || ""} ${profile?.lastName || ""}`.trim() : "";
    const displayName = lawyerName || record?.lawyerId;

    return (
        <Modal
            open={isVisible}
            onCancel={onClose}
            footer={null}
            width={420}
            className="approve-lawyer-modal"
            centered
        >
            <div className="approve-modal-content">
                <div className="approve-modal-header" style={{ marginBottom: displayName ? "8px" : "16px" }}>
                    <ExclamationCircleOutlined className="warning-icon" />
                    <h3 className="modal-title">Confirm Account Changes</h3>
                </div>
                <div style={{ textAlign: "center", marginBottom: "24px", color: "#595959", fontSize: "14px" }}>
                    Are you sure you want to approve the account changes
                    {displayName ? (
                        <>
                            {" "}for <strong style={{ color: "#262626" }}>{displayName}</strong>?
                        </>
                    ) : (
                        "?"
                    )}
                </div>
                <div className="modal-footer">
                    <UiButton 
                        className="cancel-btn"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        No
                    </UiButton>
                    <UiButton 
                        type="primary"
                        className="approve-btn-2"
                        onClick={onConfirm}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        Approve
                    </UiButton>
                </div>
            </div>
        </Modal>
    );
};

export default ApproveAccountModal;
